import React, { ReactElement } from 'react'
import dayjs from 'dayjs'

export type DateTimeCellProps = {
  style?: object
  value: string
}

export default function DateTimeCell({
  style,
  value,
}: DateTimeCellProps): ReactElement {
  return <div style={style}>{dayjs(value).format('DD-MM-YYYY HH:mm')}</div>
}
